export default __webpack_public_path__ + "static/media/urinating-more-than-usual.0fac34e6.png";